/* eslint-disable @typescript-eslint/ban-ts-comment */
import { getVisitorIdBrowser } from "@growth/visitor-id/browser";
import { getVisitorIdNode, visitorIdNode } from "@growth/visitor-id/node";
import { PARTNER } from "@tm/isomorphic-utils";
// @ts-ignore
import { getAndUpdateDvid } from "MMT-UI/helpers/client/dvid";
// @ts-ignore
import { getAndUpdateDvidOnServer } from "MMT-UI/helpers/server/dvid";

import { getPartnerOnClientSide } from "./utils";

export const getDeviceIdForClient = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const partner = getPartnerOnClientSide();
    if (partner === PARTNER.GI) {
      const vid = getVisitorIdBrowser();
      return vid as string | null;
    } else {
      const dvid = getAndUpdateDvid();
      return dvid as string | null;
    }
  } catch (error) {
    console.error("Error in getDeviceIdForClient utility:", error);
    return null;
  }
};

export const getDeviceIdForServer = (
  req: any,
  res: any,
  partner: typeof PARTNER[keyof typeof PARTNER]
): string | null => {
  try {
    let dvid = null;

    if (partner === PARTNER.GI) {
      const vidMiddleware = visitorIdNode();
      vidMiddleware(req, res, () => {
        // Middleware callback
      });
      dvid = getVisitorIdNode(req);
    } else {
      dvid = getAndUpdateDvidOnServer(req, res);
    }
    return dvid as string | null;
  } catch (error) {
    console.error("Error in getDeviceId utility:", error);
    return null;
  }
};
